import { render, staticRenderFns } from "./UsageCode.vue?vue&type=template&id=4852c1be&"
import script from "./UsageCode.vue?vue&type=script&lang=js&"
export * from "./UsageCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports